"use strict";

/* portal */

var scrollElm = (function () {
  if (document.scrollingElement) return document.scrollingElement;
  if (navigator.userAgent.indexOf("WebKit") != -1) return "body";
  return document.documentElement;
})();

var pathName = location.pathname;
var pathNameGeneral = pathName.match("/portal/general/")
var pagePath = !pathNameGeneral ? "kokkosho" : "general";
var pageCategory;
if (pagePath == "kokkosho") {
  pageCategory = "";
}
 function iframe_display() {
    $("iframe").on("load", function() {
      try {
        $(this).height(0);
        $(this).height(this.contentWindow.document.documentElement.scrollHeight);
      } catch (e) {
      }
    });
    $("iframe").trigger("load");
  }
  $(window).on('load',function() {
    iframe_display();
  });
  $(window).resize(function() {
    iframe_display();
  });
// ヘッダーアンカーリンク設定
$(window).on('load', function(){
  var _kikan = $("header").find("._kikan").find(".gnavi-link.has-arrow");
  var _info = $("header").find("._info").find(".gnavi-link.has-arrow");
  var dir = location.pathname.split("/");
  if (pathName === "/portal/" + dir[2] + "/" || pathName === "/portal/" + dir[2] + "/index.html") {
    $(_kikan).attr("href", "#sec01");
    $(_info).attr("href", "#sec02");
  } else if (dir.length >= 4) {
    $(_kikan).attr("href", "./index.html#sec01");
    $(_info).attr("href", "./index.html#sec02");
  }

  // 階層が深い時のヘッダーロゴ画像
  var hLogoImg = $("header").find(".header-logo").find("h1 img");
  if (dir.length >= 5) {
    var reldir = "../";
    var hLogoImgSrc = hLogoImg.attr("src");
    hLogoImg.attr("src", reldir.repeat(dir.length - 4) + hLogoImgSrc);
  }

  // 階層が深い時のナビ・ボタンリンク
  // ナビ
  var hNavLinks = $("header").find(".gnavi-link");
  commonPartsLink(hNavLinks);
  var hSpNavLinks = $("header").find(".menu-list-link");
  commonPartsLink(hSpNavLinks);
  var hLogoLink = $("header").find(".header-logo").children("a");
  commonPartsLink(hLogoLink);
  var fNavLinks = $("footer").find(".gnavi-link");
  commonPartsLink(fNavLinks);
  var fLink = $("footer").find(".footer-link._inner-site");
  commonPartsLink(fLink);
  // ヘッダーボタン
  var hBtn = $(".header-btn-area .btn");
  commonPartsLink(hBtn);
});

$(function () {

  setTimeout(function () {
    $winManager.onresizeSet();
    $winManager.onscrollSet();
  }, 100);
  $winManager.w = window.innerWidth ? window.innerWidth : $(window).width();
  $winManager.pcFlag = $winManager.w >= $winManager.spWide;

  $winManager.onresizeSet();
  $(window).resize($winManager.onresizeSet);


  var _headerTarget = $("header");
  var _footerTarget = $("footer");

  // header読み込み
  $.ajax({
    url: "/portal/" + pathName.split("/")[2] + "/include/header.html",
    context: _headerTarget
  }).done(function (data) {
    $(this).replaceWith(data);
    // ヘッダーナビカレント
    var directoryArray = []; //空配列を定義
    var hmenuItem = $(".gnavi-area .gnavi-list > .menu-item"); // ナビ要素
    $(hmenuItem).each(function() {
      // ヘッダーナビからhrefを抜き出す
      var _thisLink = $(this).children("a");
      var _thisHref = _thisLink.attr('href');
      // 抜き出したhrefからファイル名のみ取得、拡張子を取る
      var hrefName1 = _thisHref.split('.').slice(0, -1).join('.');
      var hrefName = hrefName1.slice(2);
      // ファイル名を配列に格納
      directoryArray.push(hrefName);
    });

    var cIndex;
    cIndex = currentIndex(directoryArray, 3);
    if (cIndex === -1) {
      $(".gnavi-area .gnavi-list > .menu-item").eq(0).children("a").addClass("is-current");
    } else if (cIndex != null) {
      $(".gnavi-area .gnavi-list > .menu-item").eq(cIndex).children("a").addClass("is-current");
    }
  });
  // footer読み込み
  $.ajax({
    url: "/portal/" + pathName.split("/")[2] + "/include/footer.html",
    context: _footerTarget
  }).done(function (data) {
    $(this).replaceWith(data);
  });

  // ハンバーガーメニュー
  $(document).on("click", "#js-menu-toggle-btn", function () {
    $(this).toggleClass("active");
    $(".gnavi-area").toggleClass("active");
    $("#top").toggleClass("fixed");
    $(".sp-menu-overlay").toggleClass("overlay");
  });
  $(document).on("click", ".gnavi-link, .sp-menu-overlay", function () {
    $("#js-menu-toggle-btn").removeClass("active");
    $(".gnavi-area").removeClass("active");
    $("#top").removeClass("fixed");
    $(".sp-menu-overlay").removeClass("overlay");
  });

  // スムーススクロール
  var urlHash = location.hash;
  if(urlHash) {
    $("body,html").stop().scrollTop(0);
    var headerHeight = $("header").height();
    setTimeout(function(){
      $(scrollElm).stop().animate({
        scrollTop:  $(urlHash).offset().top - headerHeight
      }, 350, "swing");
      return false;
    }, 100);
  }
  $(document).on("click", 'a[href^="#"]', function () {
    var hash = this.hash;
    var headerHeight = $("header").height();
    if (!hash || hash == "#") return false;
    $(scrollElm).animate({
      scrollTop: $(hash).offset().top - headerHeight
    }, 350, "swing");
    return false;
  });

  // フッター手前でストップ
  $(window).on("scroll", function () {
    var floatingElm = $("#js-floating");
    floatingElm.addClass("floating-fixed");
    var scrollHeight = $(document).height();
    var scrollPosition = $(window).height() + $(window).scrollTop();
    var footHeight = $(".footer").innerHeight();
    if (scrollHeight - scrollPosition <= footHeight) {
      floatingElm.removeClass("floating-fixed");
      floatingElm.addClass("floating-absolute");
    } else {
      if (floatingElm.hasClass("floating-absolute")) {
        floatingElm.removeClass("floating-absolute");
        floatingElm.addClass("floating-fixed");
      }
    }
  });
  $(window).trigger("scroll");

  // faqアコーディオン
  $('.js-accordion').children('.faq-list-question').on('click', function(){
    $(this).toggleClass('is-open');
    if ($(this).hasClass('is-open')) {
      $(this).next().slideDown(250);
    } else {
      $(this).next().slideUp(250);
    }
    $(this).next().css('display', 'flex');
  });

 // 2カラム右ナビfixed
  if($winManager.w > $winManager.tab) {
    if($('.article-item').length){
      $(window).on("scroll", function() {
        var navPosition = $('.article-item._nav').offset().top;
        if ($(this).scrollTop() + 220 > navPosition) {
          $('.article-item._nav').addClass('is-fixed');
        } else {
          $('.article-item._nav').removeClass('is-fixed');
        }
      });
    }
  }
});

function commonPartsLink(link) {
  var dir = location.pathname.split("/");
  if (dir.length >= 5) {
    var reldir = "../";
    link.each(function(){
      var href = $(this).attr("href");
      var hrefName = href.slice(2);
      $(this).attr("href", reldir.repeat( dir.length - 4 ) + hrefName);
    });
  }
}

function currentIndex(arr, target) {
  var _paths = location.pathname.split("/");
  var idx = null;
  $.each(arr, function(index, value){
    if (_paths[target] == "index.html" || _paths[target] == "") {
      idx = -1;
    } else if (_paths[target] == value || _paths[target] == value + ".html") {
      idx = index;
    }
  })
  return idx;
}

// Window Manager
var $winManager = {
  tab: 1025,
  spWide: 641,
  pcFlag: true,
  w: 0,
  h: 0,
  ratio: 0,
  headerH: 140,
  scrollTop: 0,
  onresizeSet: function () {
    $winManager.w = window.innerWidth ? window.innerWidth : $(window).width();
    $winManager.h = window.innerHeight ? window.innerHeight : $(window).height();
    // $winManager.ratio = $winManager.w / $winManager.h;
    if ($winManager.w > $winManager.spWide) {
      $winManager.pcFlag = true;
    } else {
      $winManager.pcFlag = false;
    }
  },
  onscrollSet: function () {},
  onScrollEffect: function () {},
};